import { isVariantOf, ComponentsVariants } from '@/components.variants';
import resolveRTC from '../resolveRTC';

export const isAccordionGroup = isVariantOf(ComponentsVariants.ACCORDION_GROUP, true);

const defaultProps = {
  groupSummary: '<h3>LOREM IPSUM</h3>',
  items: [],
};

export default (ravVal: any, page: any, pageModels: any) => {
  const { accordionGroupSummary, accordionList } = ravVal || {};

  const parseAccordionItems = (item: any) => ({
    title: resolveRTC({ rawVal: item?.accordionTitle || '' }),
    content: resolveRTC({ rawVal: item?.accordionContent || '' }),
    isCollapsed: item?.isCollapsed,
  });

  return {
    variant: ComponentsVariants.ACCORDION_GROUP,
    ...defaultProps,
    groupSummary: resolveRTC({ rawVal: accordionGroupSummary || '' }),
    items: (accordionList || []).map(parseAccordionItems),
  };
};
